export const XFactionQuestionMarkSvg = ({ width }: { width: number }) => {
  return (
    <svg
      width={width}
      height={(width / 22) * 32}
      viewBox="0 0 22 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1531 1C4.15314 1 -0.846886 7.00003 1.65314 9.5C4.15319 12 9.05315 8 10.6531 8C12.6531 8 13.6531 9.5 13.6531 11.5C13.6531 13.5 8.1532 13 7.1532 16C6.31986 18.5 7.6532 22 10.1532 22C12.6532 22 11.6531 20.5 13.1531 19C14.6531 17.5 21.1531 16 21.1531 11.5C21.1531 7 18.1531 1 11.1531 1Z"
        fill="url(#paint0_linear_298_10)"
        stroke="#4F4F4F"
      />
      <circle
        cx="10.1532"
        cy="28"
        r="3.5"
        fill="url(#paint1_linear_298_10)"
        stroke="#4F4F4F"
      />
      <defs>
        <linearGradient
          id="paint0_linear_298_10"
          x1="21"
          y1="11"
          x2="1"
          y2="7.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AE944D" />
          <stop offset="0.848958" stopColor="#DFD05E" />
          <stop offset="1" stopColor="#C5B155" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_298_10"
          x1="7"
          y1="30"
          x2="14"
          y2="26.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B7A050" />
          <stop offset="0.822917" stopColor="#E2D45F" />
          <stop offset="1" stopColor="#D7C65B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
